import * as React from 'react'
import { resourceIsAcknowledged } from '../../types/Resource'
import type { ViewDone } from '../../types/SceneViewAware'
import { MasterState } from './MasterState'
import type { inConfigType, TresourceConfig, TviewConfig } from './masterStateBuilder'

export namespace MasterStateWrapper {
    export interface Props {
        configs: inConfigType[]
        whenDone: (...rs: any) => React.ReactNode | React.ReactNode[]
        customization?: MasterState.Props['customization']
    }
}

export const MasterStateWrapper: React.FC<MasterStateWrapper.Props> = React.memo(props => {
    const resourcesConfig = props.configs.filter((c: any) => typeof c.resource !== 'undefined') as TresourceConfig<
        unknown,
        unknown,
        unknown,
        unknown,
        unknown,
        unknown,
        unknown
    >[]

    const viewsConfig = props.configs.filter((c: any) => typeof c.view !== 'undefined') as TviewConfig<
        ViewDone<unknown, unknown>,
        unknown
    >[]

    const [resourcesConfigCopy, setResourcesConfigCopy] = React.useState(resourcesConfig)

    React.useEffect(() => {
        const resourceParsed = resourcesConfig.reduce(
            (c, r, i) => {
                if (
                    (resourcesConfigCopy[i].resource.status === 'init' && r.resource.status === 'submitted') ||
                    (resourcesConfigCopy[i].resource.status === 'init' && r.resource.status === 'fulfilled') ||
                    (resourcesConfigCopy[i].resource.status === 'submitted' && resourceIsAcknowledged(r.resource))
                ) {
                    return [...c, r]
                }

                return [...c, resourcesConfigCopy[i]]
            },
            [] as TresourceConfig<unknown, unknown, unknown, unknown, unknown, unknown, unknown>[]
        )

        setResourcesConfigCopy(resourceParsed)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.configs])

    return (
        <MasterState resourceStates={resourcesConfigCopy} viewStates={viewsConfig} customization={props.customization}>
            {() => props.whenDone(...resourcesConfigCopy.map(r => r.resource), ...viewsConfig.map(v => v.view))}
        </MasterState>
    )
})
